import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class PlanningHttpService {

  private base_url = `/planning`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getProjects(params?: any): Observable<{ list: any[], cursor?: string }> {
    return this.http
      .get<{ list: any[], cursor?: string }>(this.base_url + '/projects', {params});
  }

}
